import React from "react";
import { LoginContainerStyled } from "./styled";
import { connect } from "react-redux";
import { withRouter } from "navigations/withRouter";
import queryString from "query-string";
import { toast } from "react-toastify";
import { userService } from "apiServices";
import { ROUTE_PATH } from "utils/constants/routePath";
import { ROOM_BOOKING_PAYMENT_PATH } from "utils/functions/roomBooking";
import { setReduxAuthen } from "store/reducers/authenReducer";
import { setReduxWallet } from "store/reducers/walletReducer";
import { Displays, Forms } from "components";
import liff from "@line/liff";
import { initLiff } from "utils/functions/scanQR";

class LoginContainer extends React.Component {
  state = { step: 1, email: "", authProviders: [] };

  fetchMyInfomation = async () => {
    let { page } = queryString.parse(this.props.router.location.search);
    let resArr = await Promise.all([
      userService.GET_MY_PROFILE(),
      userService.GET_MY_WALLET(),
    ]);
    if (resArr) {
      this.setState({ isBgLoading: false });
      this.props.setReduxAuthen(resArr[0].data);
      this.props.setReduxWallet(resArr[1].data);

      const pendingRedirect = sessionStorage.getItem("pendingRedirect");
      if (pendingRedirect) {
        sessionStorage.removeItem("pendingRedirect");
        const { redirect, id, room } = JSON.parse(pendingRedirect);
        switch (redirect) {
          case "activity":
            this.props.router.navigate(`${ROUTE_PATH.ACTIVITIES}/${id}`);
            return;
          case "online-form":
            this.props.router.navigate(`${ROUTE_PATH.ACTIVITY_FORM}/${id}`);
            return;
          case "activity-qr-register":
            this.props.router.navigate(`${ROUTE_PATH.ACTIVITIES}/${id}/qr-register`);
            return;
          case "room-booking-payment":
            this.props.router.navigate(ROOM_BOOKING_PAYMENT_PATH({ id, room }));
            return;
          default:
            break;
        }
      }
      this.props.router.navigate(!page ? ROUTE_PATH.HOME : ROUTE_PATH[page]);
    }
  };

  // Step 1: check-email API
  handleStep1Submit = async (values) => {
    this.setState({ isBgLoading: true });
    let res = await userService.POST_CHECK_EMAIL({ email: values.username });
    if (res && res.status === 200) {
      if (res.exists && res.has_password) {
        // มี account + password → ไปกรอก password ได้เลย
        this.setState({
          isBgLoading: false,
          step: 2,
          email: values.username,
        });
      } else if (res.exists && !res.has_password) {
        // มี account แต่ไม่มี password (สมัครผ่าน Google/Line) → ส่ง OTP แล้วไปตั้งรหัสผ่าน
        let otpRes = await userService.POST_SET_PASSWORD_REQUEST({
          email: values.username,
        });
        if (otpRes && otpRes.status === 200) {
          this.setState({
            isBgLoading: false,
            step: 3,
            email: values.username,
            authProviders: res.auth_providers || [],
          });
        } else {
          this.setState({ isBgLoading: false });
          toast.error(otpRes?.data?.error?.message || "ไม่สามารถส่ง OTP ได้");
        }
      } else {
        // ไม่มี account → สมัครใหม่
        this.setState({ isBgLoading: false });
        this.props.router.navigate(
          `${ROUTE_PATH.REGISTER}?email=${encodeURIComponent(values.username)}`,
        );
      }
    } else if (res) {
      this.setState({ isBgLoading: false });
      toast.error(res?.data?.error?.message || "Something went wrong");
    } else {
      // res === null (429) → interceptor แสดง toast แล้ว
      this.setState({ isBgLoading: false });
    }
  };

  // Step 2: password login
  handleStep2Submit = async (values) => {
    this.setState({ isBgLoading: true });
    let res = await userService.POST_LOGIN({
      email: values.username,
      password: values.password,
    });
    if (res && res.status === 200) {
      localStorage.setItem("token", res.token);
      this.fetchMyInfomation();
    } else {
      this.setState({ isBgLoading: false });
      toast.error(res?.data?.error?.message || "Login failed");
    }
  };

  // Google login
  handleGoogleLogin = async (accessToken) => {
    this.setState({ isBgLoading: true });
    let res = await userService.POST_LOGIN_GOOGLE({
      access_token: accessToken,
    });
    if (res && res.status === 200) {
      localStorage.setItem("token", res.token);
      this.fetchMyInfomation();
    } else if (res && res.Message === "not_registered") {
      this.setState({ isBgLoading: false });
      const data = res.data;
      this.props.router.navigate(
        `${ROUTE_PATH.REGISTER}?googleID=${data.google_id}&email=${encodeURIComponent(data.email)}&first_name=${encodeURIComponent(data.first_name)}&last_name=${encodeURIComponent(data.last_name)}&avatar=${encodeURIComponent(data.img_path)}`,
      );
    } else {
      toast.error(res?.data?.error?.message || "Google login failed");
    }
  };

  handleLineLogin = async () => {
    try {
      await initLiff();
      // user อยู่หน้า login = ต้องการ login ใหม่
      // ถ้ามี session เก่าค้าง → logout ก่อนเพื่อให้ได้ token สด
      if (liff.isLoggedIn()) {
        liff.logout();
      }
      liff.login();
    } catch (err) {
      console.error("LIFF init failed:", err);
      toast.error("ไม่สามารถเชื่อมต่อ LINE ได้ กรุณาลองใหม่");
    }
  };

  // Step 3: ตั้งรหัสผ่าน (OTP + password ใหม่)
  handleSetPasswordSubmit = async (values) => {
    this.setState({ isBgLoading: true });
    let res = await userService.POST_SET_PASSWORD({
      email: this.state.email,
      otp: values.otp,
      password: values.password,
    });
    if (res && res.status === 200) {
      localStorage.setItem("token", res.token);
      this.fetchMyInfomation();
    } else {
      this.setState({ isBgLoading: false });
      toast.error(res?.data?.error?.message || "ไม่สามารถตั้งรหัสผ่านได้");
    }
  };

  handleResendOTP = async () => {
    let res = await userService.POST_SET_PASSWORD_REQUEST({
      email: this.state.email,
    });
    if (res && res.status === 200) {
      toast.success("ส่งรหัส OTP ใหม่แล้ว");
    } else {
      toast.error(res?.data?.error?.message || "ไม่สามารถส่ง OTP ได้");
    }
  };

  onForgetPassword = () => {
    const { email } = this.state;
    this.props.router.navigate(
      `${ROUTE_PATH.FORGET_PASSWORD}${email ? `?email=${encodeURIComponent(email)}` : ""}`
    );
  };

  render() {
    const { isBgLoading, step, email, authProviders } = this.state;
    return (
      <LoginContainerStyled>
        <Displays.BGLoading visible={isBgLoading} />
        {step === 1 && (
          <Forms.LoginStep1Form
            onSubmit={this.handleStep1Submit}
            onGoogleLogin={this.handleGoogleLogin}
            onLineLogin={this.handleLineLogin}
          />
        )}
        {step === 2 && (
          <Forms.LoginStep2Form
            defaultEmail={email}
            onForgetPassword={this.onForgetPassword}
            onSubmit={this.handleStep2Submit}
          />
        )}
        {step === 3 && (
          <Forms.SetPasswordForm
            email={email}
            authProviders={authProviders}
            onSubmit={this.handleSetPasswordSubmit}
            onResendOTP={this.handleResendOTP}
          />
        )}
      </LoginContainerStyled>
    );
  }
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({
  setReduxAuthen: (data) => dispatch(setReduxAuthen(data)),
  setReduxWallet: (data) => dispatch(setReduxWallet(data)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(LoginContainer));
